import axios from "axios";
import {
  getStoredToken,
  isTokenExpired,
  clearAuthAndRedirectToLogin,
} from "../utils/auth";

const WABA_API_BASE = process.env.REACT_APP_WABA_SERVER_URL;

const catalogAPI = axios.create({
  baseURL: `${WABA_API_BASE}/api/catalog`,
  headers: { "Content-Type": "application/json" },
});

catalogAPI.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (!token || isTokenExpired(token)) {
    clearAuthAndRedirectToLogin();
    return Promise.reject(new Error("Token expired"));
  }
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

catalogAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAuthAndRedirectToLogin();
    }
    return Promise.reject(error);
  }
);

export const listCatalogs = (phoneId, params) => catalogAPI.get(`/${phoneId}`, { params });
export const createCatalog = (phoneId, payload) => catalogAPI.post(`/${phoneId}`, payload);
export const connectCatalog = (phoneId, catalogId) =>
  catalogAPI.post(`/${phoneId}/connect`, { catalogId });
export const disconnectCatalog = (phoneId, catalogId) =>
  catalogAPI.post(`/${phoneId}/disconnect`, { catalogId });
export const listProducts = (phoneId, params) =>
  catalogAPI.get(`/${phoneId}/products`, { params });
export const createProduct = (phoneId, payload) =>
  catalogAPI.post(`/${phoneId}/products`, payload);
export const listOrders = (phoneId, params) =>
  catalogAPI.get(`/${phoneId}/orders`, { params });
export const getCommerceSettings = (phoneId) =>
  catalogAPI.get(`/${phoneId}/commerce-settings`);
export const updateCommerceSettings = (phoneId, payload) =>
  catalogAPI.post(`/${phoneId}/commerce-settings`, payload);
export const generateFbCatalogLink = (phoneId) =>
  catalogAPI.post(`/${phoneId}/fb-catalog-link`);
